import { useCallback } from "react";
import { useQueryState } from "./useQueryState";
import { useSearchUtils } from "../../../hooks/useSearch";
import { getSearchQueryParamName } from "./const";

export const useRegimenSearch = () => {
  const [searchTerm, setSearchTerm] = useQueryState(getSearchQueryParamName());
  const handleSearchTermChange = useCallback(
    (e) => setSearchTerm(e.target.value),
    [setSearchTerm]
  );
  const searchUtils = useSearchUtils(searchTerm);

  return { searchTerm, setSearchTerm, handleSearchTermChange, searchUtils };
};
